export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f40a2fc40193afa2fb7221d60c91efbd352798693&name=fetchTypeahead!'